import * as React from 'react';
import c from 'classnames';
import Immutable from 'immutable';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { DynamicMediaItem, Paragraph } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import { Hero } from '../../../../components';
import type { TaxonomyTargetAudience } from '../../../../types/uncinc_profile/taxonomy';

interface TargetAudienceProps {
  entity: ImmutableEntity<TaxonomyTargetAudience>;
}

const TaxonomyTargetAudiencePage: React.FC<TargetAudienceProps> = ({ entity }) => {
  const targetAudience = entity.toJS();
  const id = targetAudience.tid[0].value;

  const classes = c('TaxonomyTargetAudiencePage');

  return (
    <div className={classes}>
      <Hero
        title={targetAudience.name[0].value}
        body={targetAudience.description[0].value || ''}
        media={<DynamicMediaItem media={targetAudience.field_media_item[0]} imageAspectRatio="4_3" aboveTheFold />}
        containMedia={targetAudience.field_media_item[0].bundle === 'svg'}
        background="primary"
      />
      <Container>
        <div className="content-section">
          <div className="row">
            <div className="col-md-7">
              {targetAudience.field_paragraphs && (
                <>
                  {targetAudience.field_paragraphs.map((paragraph) => {
                    const paragraphId = paragraph.target_id;
                    const language = paragraph.entity.langcode[0].value;
                    return (
                      <Paragraph
                        key={`paragraph:${id}:${language}`}
                        id={paragraphId}
                        entity={Immutable.fromJS(paragraph.entity)}
                      />
                    );
                  })}
                </>
              )}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default TaxonomyTargetAudiencePage;
